import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import EditMemberContactInfo from './EditMemberContactInfo';
//import { getViewEmployeeDetails } from '../../../../utils/common';
//import useProfile from '../../../ViewMember/Profile/hooks/useProfile';
//import './styles/profile.scss';
import './styles/member-info.scss';

const EditMemberInfo = ({
  enrollmentFormData,
  setEnrollmentFormData,
  nextStep,
  prevStep,
  setShowEditMemberContactDetails,
  employeeInfo,
  residentialAddress,
  mailingAddress,
  // setResponseData,
}) => {
  console.log('Edit MemberInfo enrollmentFormData', enrollmentFormData);

  /*Personal details */
  /*const {
    MemberInformation = {},
    Memberresidentailaddress = {},
    Membermailingaddress = {},
    //DependentsInfo = {},
    //DependentsInformation = {},
    //Dependentresidentailaddress = {},
    //Dependentmailingaddress = {},
  } = useSelector((state) => state.memberSummary.viewMember || {});*/

  //const { employeeInfo, residentialAddress, mailingAddress } = useProfile();
  /*const { memberDetails } = useSelector((state) => state.memberModule || {});
  const loggedInMemberType = memberDetails?.Member?.LoggedInMemberType;
  const loggedInUserOID = memberDetails?.Member?.LoggedInUserOID;*/
  const { selectedMember } = useSelector((state) => state.memberModule || {});
  const loggedInUserOID = selectedMember.ID;
  const loggedInMemberType = selectedMember.mType;
  console.log('Edit MemberInfo loggedInUserOID', loggedInUserOID);

  /*const { loggedInUserOID, loggedInMemberType } = useSelector(
    (state) => state.memberSummary || {},
  );*/

  /*const employeeInfo = getViewEmployeeDetails(
    loggedInMemberType === 'Employee'
      ? MemberInformation
      : DependentsInformation,
    loggedInMemberType === 'Employee' ? false : true,
  );*/

  //const employeeInfo = getViewEmployeeDetails(MemberInformation);

  console.log(
    'EditMemberInfo employeeInfo',
    employeeInfo,
    residentialAddress,
    mailingAddress,
  );
  const suffix = employeeInfo?.Suffix ? employeeInfo?.Suffix : '';
  const fName =
    employeeInfo?.FirstName?.charAt(0).toUpperCase() +
    employeeInfo?.FirstName?.slice(1).toLowerCase();
  const lName =
    employeeInfo?.LastName?.charAt(0).toUpperCase() +
    employeeInfo?.LastName?.slice(1).toLowerCase();
  const fullName = suffix + fName + ', ' + lName;

  return (
    <div>
      <div className="member-info-header">
        <div>
          Update Address for <span className="full-name">{fullName}</span>
        </div>
      </div>
      <div className="member-selection-content my-profile-member-container edit-member-container">
        <div className="bg-white all-profile-component-wrapper">
          <EditMemberContactInfo
            enrollmentFormData={enrollmentFormData}
            setEnrollmentFormData={setEnrollmentFormData}
            data={{
              employeeInfo,
              residentialAddress,
              mailingAddress,
            }}
            loggedInUserOID={loggedInUserOID}
            loggedInMemberType={loggedInMemberType}
            nextStep={nextStep}
            prevStep={prevStep}
            setShowEditMemberContactDetails={setShowEditMemberContactDetails}
            // setResponseData={setResponseData}
          />
        </div>
      </div>
    </div>
  );
};

export default EditMemberInfo;
